jQuery(function ($) {

    jQuery('.contact-us-form .btn-submit').on('click', function(e) {
       e.preventDefault();

       jQuery(this).closest('form').trigger('submit');
    });

    jQuery('form.contact-us-form').on('submit', function (e) {
        e.preventDefault();

        let $form = jQuery(this),
            formData = $form.serializeArray(),
            $page = $('#contact_us_page'),
            $resultContent = $('#form_result .content');

        Page.startLoad('contact-us-form', $form);
        jQuery.post(ajaxurl, formData, function (result) {
            Validator.removeErrors($form);

            //validation errors
            if (typeof result.errors !== 'undefined' && result.errors.length > 0) {
                Validator.validate($form, result.errors);
            }

            if (typeof result.success !== 'undefined' && result.success === true) {
                $page.addClass('with-response');
                $resultContent.find('h3').html(result.message);

                if (typeof result.description !== 'undefined' && result.description) {
                    $resultContent.find('p').html(result.description);
                }
            }

            Page.finishLoad('contact-us-form');
        }, 'json');
    });
});
